import { ReactComponent as ReferralIcon } from '@assets/icons/V4/referral-icon.svg';
import Button from '@components/V4/Button';
import { BASE_URL } from '@shared/frontendEnv';
import { useTranslation } from 'apps/agora/src/TranslationContext';

const ParentPageReferralCard = () => {
  const { t } = useTranslation();

  return (
    <section className="mt-14 flex flex-col items-center justify-center gap-2 relative bg-surfaceObject rounded-xl px-6 pb-4 w-full">
      <ReferralIcon className="absolute -top-[25%]" />

      <h2 className="font-raleway font-bold text-xl text-center mt-10">
        {t('parent_referral_title')}
      </h2>

      <div className="w-full ">
        <p className="text-center max-w-[330px] font-semibold text-xsm m-auto leading-5">
          {t('parent_referral_description')}
        </p>
      </div>
      <a href={`${BASE_URL}/referral`} target="_blank" rel="noreferrer" className="w-full">
        <Button
          buttonText={t('parent_referral_button')}
          variant="gold"
          multiline
          className="w-full text-center"
        />
      </a>
    </section>
  );
};

export default ParentPageReferralCard;
